module.exports = __webpack_public_path__ + "img/leakinstreet_attached.f95f71f3.svg";